<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div id="snowzone"></div>
    <audio id="audio" v-if="isBirthDay" muted autoplay="autoplay"  src="https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/%E7%BA%AF%E9%9F%B3%E4%B9%90%20-%20%E7%94%9F%E6%97%A5%E5%BF%AB%E4%B9%90%20%28%E9%92%A2%E7%90%B4%E7%89%88%E9%93%83%E5%A3%B0%29.mp3">
    </audio>
    <div class="container" :class="isBirthDay?'birthDayClass':''" :style="isBirthDay?{}:containerStyle">
      <div class="top">
        <div class="header">
          <a href="/">
            <img :src="logoUrl" class="logo" alt="logo"/>
            <span class="title">3.0</span>
          </a>
        </div>
      </div>
      <route-view></route-view>
      <div class="footer">
        <div class="copyright">
          {{ $t('userLayout.copyright2019ShenzhenDaoyuanCommercialRealEstate') }} <a href="http://beian.miit.gov.cn" class="copyright" target="_blank">{{ $t('userLayout.guangdongICPNo16030432') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteView from './RouteView'
import { mixinDevice } from '@/utils/mixin'
import moment from 'moment'
import { mapState } from 'vuex'
import {selectBirthDay} from '@/api/login'
import logoUrl from '@/assets/logo_blackfont_login.png'
export default {
  name: 'UserLayout',
  components: { RouteView },
  mixins: [mixinDevice],
  data () {
    return {
      logoUrl,
      bgImages:[
        {url:"https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/0-6.png",start:0,end:6},
        {url:"https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/6-8.png",start:6,end:8},
        {url:"https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/8-9.png",start:8,end:9},
        {url:"https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/9-10.png",start:9,end:10},
        {url:"https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/10-12.png",start:10,end:12},
        {url:"https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/12-14.png",start:12,end:14},
        {url:"https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/14-16.png",start:14,end:16},
        {url:"https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/16-18.png",start:16,end:18},
        {url:"https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/18-19.png",start:18,end:19},
        {url:"https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/19-20.png",start:19,end:20},
        {url:"https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/20-21.png",start:20,end:21},
        {url:"https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/21-22.png",start:21,end:22},
        {url:"https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/22-24.png",start:22,end:24}
      ],
      isBirthDay:false,
      gifs:[],
    }
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  },
  mounted () {
    document.body.classList.add('userLayout')
    this.selectLoginNames()
  },
  computed:{
    ...mapState({
      historyUserName: state => state.i18n.userName
    }),
    containerStyle(){
       return this.getStyle()
    }
  },
  deactivated() {
    document.removeEventListener('click')
  },
  methods:{
    selectLoginNames(){
      selectBirthDay(this.historyUserName).then(res=>{
        if(res.code == 1){
          this.isBirthDay = res.data
          if(this.isBirthDay){
            this.addImages();
            this.audioLoad()
          }
        }
      })
    },
    audioLoad(){
      document.addEventListener('click', ()=>{
        document.getElementById("audio").play()
      })
    },
    addImages(){
      let interVal = setInterval(()=>{
        let left = Math.random()*window.innerWidth;
        let height = Math.random()*window.innerHeight;
        this.snow(left,height);
      },100);
      setTimeout(()=>{
        clearInterval(interVal);
      },13000);
    },
    snow(left,height){
      let div = document.createElement("div");
      let img = document.createElement("img");
      div.appendChild(img);
      img.className = "gif_img";
      img.src = "https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/s1.png";
      div.style.left=left+"px";
      div.style.zIndex=5;
      div.style.height=height+"px";
      div.style.position="fixed"
      div.className="gif_div"
      document.getElementById("snowzone").appendChild(div);
      setTimeout(function(){
        // document.getElementById("snowzone").removeChild(div);
        // console.log(window.innerHeight);
      },10000);
    },
    getStyle(){
      let hours = moment().format("HH");
      console.log(hours)
      let style = {backgroundImage:''}
      let data = this.bgImages.filter((data)=>{
        return data.start <= hours && data.end > hours;
      })
      console.log(data)
      style.backgroundImage = "url("+data[0].url+")"
      return style;
    }
  },

}
</script>
<style>
  @keyframes mysnow{
    0%{
      bottom: 100%;
      opacity:1;
    }

    100%{
      transform: translateY(100vh);
      opacity: 1;
      bottom:0;
    }
  }
  .gif_div{
    position: fixed;
  }
  .gif_img{
    position: absolute;
    opacity: 0;
    animation: mysnow 10s;
    height: 32px;
    width: 30px;
  }
</style>
<style lang="less" scoped>
  .birthDayClass{
    width: 100%;
    height: 100vh;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #ffffff;
    background-image: url("https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/%E8%83%8C%E6%99%AF%E5%9B%BE.png");

  }


  #userLayout.user-layout-wrapper {
    height: 100%;

    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;
        }
      }
    }

    .container {
      width: 100%;
      height: 100vh;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      background-color: #ffffff;
      padding: 110px 0 144px;
      position: relative;
      a {
        text-decoration: none;
      }

      .top {
        text-align: center;
        position: relative;
        .header {
          height: 44px;
          line-height: 44px;
          margin-bottom: 80px;
          position: relative;
          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 12px;
            color: rgba(255, 255, 255, .7);
            font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
            position: relative;
            top:14px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        margin: 0 auto;
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: rgb(255, 255, 255);
          font-size: 14px;
        }
      }
    }
  }
</style>
